(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactProgressiveImageBlur", ["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactProgressiveImageBlur"] = factory(require("react"));
	else
		root["ReactProgressiveImageBlur"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition